"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Text = _interopRequireDefault(require("../Input/Text"));

var _Button = _interopRequireDefault(require("../Button/Button"));

var _close = _interopRequireDefault(require("@parchment/ui-icons/lib/ai/close-2"));

require("./ComboButton.less");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ComboButton = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ComboButton, _Component);

  var _super = _createSuper(ComboButton);

  function ComboButton(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ComboButton);
    _this = _super.call(this, props);
    _this.state = {
      value: ''
    };
    return _this;
  }

  (0, _createClass2.default)(ComboButton, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        value: nextProps.value
      });
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit() {
      this.props.submit(this.state.value);
    }
  }, {
    key: "handleClear",
    value: function handleClear() {
      if (typeof this.props.clear == 'function') {
        this.props.clear();
      }

      this.setState({
        value: ''
      });
    }
  }, {
    key: "renderIcon",
    value: function renderIcon() {
      if (this.props.icon != null) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "ui-input-icon"
        }, this.props.icon);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "combo-button ".concat(this.props.size)
      }, this.renderIcon(), /*#__PURE__*/_react.default.createElement(_Text.default, {
        type: "text",
        className: "search-input",
        size: this.props.size,
        value: this.state.value,
        placeholder: this.props.placeholder,
        onChange: function onChange(value) {
          _this2.setState({
            value: value
          });
        },
        onKeyDown: function onKeyDown(e) {
          if (e.key == 'Enter') {
            _this2.handleSubmit();
          }
        },
        hideValidation: true
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "search-clear"
      }, /*#__PURE__*/_react.default.createElement(_close.default, {
        className: this.state.value != '' ? '' : 'apply-offset',
        onClick: function onClick() {
          _this2.handleClear();
        }
      })), /*#__PURE__*/_react.default.createElement(_Button.default, {
        className: "".concat(this.props.buttonType),
        onSubmit: function onSubmit() {
          _this2.handleSubmit();
        },
        size: this.props.size
      }, this.props.children));
    }
  }], [{
    key: "propTypes",
    value: function propTypes() {
      return {
        placeholder: _propTypes.default.string,
        buttonType: _propTypes.default.string,
        value: _propTypes.default.string,
        icon: _propTypes.default.node,
        children: _propTypes.default.node,
        size: _propTypes.default.oneOf(['smallest', 'small', '', 'large'])
      };
    }
  }, {
    key: "defaultProps",
    get: function get() {
      return {
        value: '',
        icon: null,
        placeholder: '',
        buttonType: 'secondary',
        children: 'Search',
        size: ''
      };
    }
  }]);
  return ComboButton;
}(_react.Component);

exports.default = ComboButton;